<template>
    <CCard class="mb-0 h-100" v-show="!storePageLoading">
        <CCardHeader class="object-header">
            <CRow>
                <CCol
                    ><h1 class="page__title text-center">
                        {{ $t(titlePage) }}
                    </h1></CCol
                >
                <CCol> </CCol>
            </CRow>
            <!-- Title page -->
        </CCardHeader>
        <CCardBody class="main-card-body">
            <CContainer fluid class="p-0">
                <!-- Filter -->
                <CRow class="justify-content-end p-2 mb-4">
                    <CCol md="6">
                        <FilterDate @updateData="updateData" />
                    </CCol>
                </CRow>
                <CRow class="p-2 m-0">
                    <CCol md="12" sm="12">
                        <!-- Filter -->
                        <FilterFields
                            :fields="tables.throttlingDeliveries.fields"
                            @filter="updateData"
                        />
                    </CCol>
                </CRow>
                <CRow
                    v-show="
                        hasItemsInTable({
                            tableName: 'throttlingDeliveries',
                        })
                    "
                >
                    <CCol xl="12" md="12" class="mb-4">
                        <CCard>
                            <CCardHeader>
                                <div class="d-flex">
                                    <TableSettings
                                        :allFields="
                                            tables.throttlingDeliveries
                                                .allFields
                                        "
                                        :activeFields.sync="
                                            tables.throttlingDeliveries.fields
                                        "
                                    />
                                </div>
                            </CCardHeader>
                            <CCardBody>
                                <CCTable
                                    :addTableClasses="['table--sm']"
                                    :items="tables.throttlingDeliveries.items"
                                    :fields.sync="
                                        tables.throttlingDeliveries.fields
                                    "
                                    :items-per-page="
                                        tables.throttlingDeliveries.rows
                                    "
                                    :loading="
                                        tables.throttlingDeliveries.loading
                                    "
                                    :columnFilterValue.sync="
                                        tables.throttlingDeliveries
                                            .columnFilterValue
                                    "
                                    :sorterValue.sync="
                                        tables.throttlingDeliveries.sorterValue
                                    "
                                    @update:column-filter-value="updateData()"
                                    @update:sorter-value="updateData()"
                                    @pagination-change="itemPerPage"
                                    v-bind="tables.throttlingDeliveries"
                                    :resizable="true"
                                >
                                    <template #over-table>
                                        <CContainer :fluid="true">
                                            <CRow alignHorizontal="start">
                                                <CDropdown
                                                    color="primary"
                                                    :toggler-text="
                                                        $t('actions')
                                                    "
                                                    class="m-2"
                                                    :disabled="
                                                        tables
                                                            .throttlingDeliveries
                                                            .itemSelected ===
                                                        null
                                                    "
                                                >
                                                    <CDropdownItem
                                                        tag="div"
                                                        @click="
                                                            $router.push({
                                                                name: 'throttling_delivery_logs',
                                                                params: {
                                                                    uuid: tables
                                                                        .throttlingDeliveries
                                                                        .itemSelected
                                                                        .Uuid,
                                                                },
                                                            })
                                                        "
                                                    >
                                                        <strong>{{
                                                            $t("Logs")
                                                        }}</strong>
                                                    </CDropdownItem>
                                                    <CDropdownItem
                                                        tag="div"
                                                        @click="
                                                            stop(
                                                                tables
                                                                    .throttlingDeliveries
                                                                    .itemSelected
                                                            )
                                                        "
                                                        :disabled="
                                                            tables
                                                                .throttlingDeliveries
                                                                .itemSelected &&
                                                            tables
                                                                .throttlingDeliveries
                                                                .itemSelected
                                                                .Status !=
                                                            'pending'
                                                        "
                                                    >
                                                        <strong>{{
                                                            $t("Stop")
                                                        }}</strong>
                                                    </CDropdownItem>
                                                </CDropdown>
                                            </CRow>
                                        </CContainer>
                                    </template>
                                    <template #_selected="{ item }">
                                        <CInputRadio
                                            name="_selected"
                                            :checked="
                                                item ===
                                                tables.throttlingDeliveries
                                                    .itemSelected
                                            "
                                            @update:checked="
                                                selectItemTable(
                                                    'throttlingDeliveries',
                                                    item
                                                )
                                            "
                                        />
                                    </template>
                                    <template #destinationName="{ item }">
                                        <td>
                                            <RouterLink
                                                v-if="item.destinationType === 'balancer'"
                                                :to="`/app/delivery-campaigns/groups/${item.destinationId}/details`"
                                            >{{ item.destinationName }}</RouterLink>
                                            <RouterLink
                                                v-else
                                                :to="
                                                    applyQueryToRoute({
                                                        route: '/app/delivery_campaings',
                                                        query: {
                                                            where: {
                                                                id: {
                                                                    equal: item.destinationId,
                                                                },
                                                            },
                                                        },
                                                    })
                                                "
                                            >{{ item.destinationName }}</RouterLink>
                                        </td>
                                    </template>
                                </CCTable>
                            </CCardBody>
                            <CCardFooter
                                v-show="
                                    tables.throttlingDeliveries.items.length > 0
                                "
                            >
                                <div class="position-relative">
                                    <CPagination
                                        @update:activePage="updatePagination"
                                        :activePage="
                                            tables.throttlingDeliveries.page
                                        "
                                        :pages="
                                            tables.throttlingDeliveries
                                                .total_pages
                                        "
                                        align="center"
                                    />
                                    <CElementCover
                                        :opacity="0.8"
                                        class="bg-trasparent"
                                        v-if="
                                            tables.throttlingDeliveries.loading
                                        "
                                    />
                                </div>
                            </CCardFooter>
                        </CCard>
                    </CCol>
                </CRow>
            </CContainer>
            <NoItemsContainer
                v-show="
                    !hasItemsInTable({
                        tableName: 'throttlingDeliveries',
                    })
                "
            >
                <template #title> Don't have Throttling deliveries</template>
                <template #description
                    >You cannot see any throlling delivery, try to search
                    another range of dates or filters</template
                >
                <template #cleanFilter>
                    <CButton
                        color="primary"
                        class="button"
                        v-show="
                            hasFiltersInTable({
                                tableName: 'throttlingDeliveries',
                            })
                        "
                        @click="
                            cleanFiltersAdvance('throttlingDeliveries'),
                                updateData()
                        "
                    >
                        <span class="button__icon">
                            <CIcon :content="$options.icons.eraser" />
                        </span>
                        <span class="button__text">
                            {{ $t("Clean Filter") }}
                        </span>
                    </CButton>
                </template>
            </NoItemsContainer>
        </CCardBody>
    </CCard>
</template>

<script>
/** Components */
import FilterDate from "~/components/FilterDate";
import ButtonCreate from "~/components/ButtonCreate";
import FilterFields from "~/components/FilterFields";
import ButtonExport from "~/components/ButtonExport";
import NoItemsContainer from "~/components/NoItemsContainer";
import CCTable from "~/components/CCTable";
/** Mixins */
import pageMixin from "~/mixins/page.js";
import tableMixin from "~/mixins/table.js";
import TableSettings from "£lement/TableSettings";
/** Icons */
import { eraser } from "~/assets/icons/js/eraser";

/** Others */
import {
    cilPlus,
    cilSettings,
    cilTrash,
    cilGroup,
    cilArrowThickFromRight,
} from "@coreui/icons";
import Swal from "sweetalert2";

export default {
    name: "ThrottlingDeliveriesMainPage",
    middleware: ["auth", "page"],
    mixins: [pageMixin, tableMixin],
    components: {
        FilterDate,
        ButtonCreate,
        FilterFields,
        ButtonExport,
        NoItemsContainer,
        TableSettings,
        CCTable,
    },
    icons: {
        cilPlus,
        cilSettings,
        cilTrash,
        cilGroup,
        cilArrowThickFromRight,
        eraser,
    },
    watch: {
        "tables.throttlingDeliveries.loading": {
            handler(newValue) {
                this.updatePageLoading(newValue);
            },
            deep: true,
        },
    },
    data() {
        return {
            tables: {
                throttlingDeliveries: {
                    fields: [
                        {
                            key: "_selected",
                            label: "",
                            fixed: true,
                            sortable: false,
                            active: true,
                            filter: false,
                            _filter: false,
                        },
                        {
                            key: "Id",
                            label: "#",
                            sorter: true,
                            filter: true,
                            _filter: true,
                            active: true,
                        },
                        {
                            key: "Uuid",
                            label: "Uuid",
                            sorter: false,
                            filter: true,
                            _filter: true,
                            _active: true,
                        },
                        {
                            key: "destinationName",
                            label: "Destination",
                            sorter: false,
                            filter: true,
                            _filter: true,
                            active: true,
                        },
                        {
                            key: "destinationType",
                            label: "Type",
                            sorter: false,
                            filter: true,
                            _filter: true,
                            active: true,
                        },
                        {
                            key: "Status",
                            label: "Status",
                            sorter: false,
                            filter: false,
                            _filter: true,
                            active: true,
                        },
                        {
                            key: "Total",
                            label: "Total",
                            sorter: false,
                            filter: false,
                            _filter: true,
                            active: true,
                        },
                        {
                            key: "Sent",
                            label: "Sent",
                            sorter: false,
                            filter: false,
                            _filter: true,
                            active: true,
                        },
                        {
                            key: "Pending",
                            label: "Pending",
                            sorter: false,
                            filter: false,
                            _filter: true,
                            active: true,
                        },
                        {
                            key: "StartDatetime",
                            label: "Start Datetime",
                            sorter: false,
                            filter: false,
                            _filter: true,
                            active: true,
                        },
                        {
                            key: "CreatedAt",
                            label: "Creation at",
                            sorter: false,
                            filter: false,
                            _filter: false,
                            active: true,
                        },
                        {
                            key: "UpdatedAt",
                            label: "Updated at",
                            sorter: false,
                            filter: false,
                            _filter: false,
                            active: true,
                        },
                    ],
                    allFields: [],
                    items: [],
                    order: "desc",
                    rows: 5,
                    page: 1,
                    matchResponseCurrentPage: "currentPage",
                    total_pages: 1,
                    matchResponsePages: "pages",
                    loading: true,
                    hover: true,
                    pagination: true,
                    sorter: {
                        external: true,
                        resetable: true,
                    },
                    sorterValue: {},
                    size: "sm",
                    columnFilter: {
                        external: true,
                        lazy: true,
                    },
                    dateFieldFilter: "CreatedAt",
                    orderField: "CreatedAt",
                    matchResponse: "data",
                    columnFilterValue: {},
                    itemsPerPageSelect: true,
                    itemSelected: null,
                    loadQueryFromUrl: true,
                },
            },
        };
    },
    methods: {
        async updateData() {
            await this.updateTable({
                tableName: "throttlingDeliveries",
                fetch: {
                    baseURL: process.env.VUE_APP_API_SASS,
                    // baseURL: process.env.VUE_APP_API_SASS_OFFLINE,
                },
                url: `/throttling-service/throttling-deliveries`,
            });

            this.tables.throttlingDeliveries.itemSelected = null;

            this.$store.dispatch("page/updateLoading", {
                loading: false,
            });
        },

        async stop(item) {
            try {
                let result = await Swal.fire({
                    title: this.$t("Are you sure?"),
                    text: this.$t(
                        "You are sure to stop this throttling delivery"
                    ),
                    icon: "warning",
                    showCancelButton: true,
                    confirmButtonColor: "#3085d6",
                    cancelButtonColor: "#d33",
                    confirmButtonText: this.$t("Yes, stop it!"),
                });
                if (result.isConfirmed) {
                    this.updatePageLoading(true);
                    await this.fetcher({
                        baseURL: process.env.VUE_APP_API_SASS,
                        // baseURL: process.env.VUE_APP_API_SASS_OFFLINE,
                        url: `/throttling-service/throttling-deliveries/${item.Uuid}/stop`,
                        method: "PATCH",
                    });
                    this.updateData();
                    this.showMessageSuccess();
                }
            } catch (error) {
                this.showMessageError(error);
            } finally {
                this.updatePageLoading(false);
            }
        },
    },
    mounted() {
        this.updateData();
    },
};
</script>
